const __WEBPACK_NAMESPACE_OBJECT__ = require("launchdarkly-react-client-sdk");